import React from 'react'
import imageOne from '../../resource/dana/pindapatha/2.png'
import imageThree from '../../resource/dana/pindapatha/1.png'
import TitleChnage from '../../Hook/TitleChnage'

import { Carousel } from "../Corousel/Carousel";

import data from "../../data/carouselData.json";

const Pindapatha = () => {
  TitleChnage("Pindapatha")
  return (
    <div className="pindapatha-page inside-pages">
    <div className="right-box">
        <img src={imageOne} alt="Right Top Image" className="right-image" width={300} />
    </div>

    <h1 className='font-main dark-gold p-4 mt-4'>Pindapatha Video</h1>

    <div className="poem-1 mt-6 h4-bold p-4">
                <div>
                    <p >Make this place bright and radiant, </p>
                    <p >A gateway to the heavenly realm of glory.</p>
                    <p >With hearts and minds devoted to service, </p>
                    <p >May we feel joy in each passing day.</p>

                    <p >The Maha Sangha, conquerors of sin, </p>
                    <p >March forward unhindered, </p>
                    <p >Their vision unwavering.</p>
                    <p >Resolute in their path, </p>
                    <p >They journey ever onward towards the truth, </p>
                    <p >Drawing ever closer to the light of wisdom.</p>

                </div>
            </div>


            <div className="video-box"></div>

            <div className="pindapatha-image p-4">
              <div className=" mt-6">
                        <Carousel data={data.poojaceremony} />
                      </div>
            </div>

            <div className="bottom-box mt-5">
                <img src={imageThree} alt="bottom-image" width={600} />
            </div>
    </div>
  )
}

export default Pindapatha
